export default {
  name: 'KRow',
  componentName: 'KRow',
  props: {
    debug: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'div',
    },
    gutter: {
      // 缝
      type: Number,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    // horizontal arrange: start end center space-around space-between
    justify: {
      type: String,
      default: 'start',
    },
    // vertical arrange: top middle bottom
    align: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {}
  },
  computed: {
    innerGutter() {
      // when use km-row as value of tag of transition-group, gutter won't received by props, so use attrs instead
      return this.gutter || (this.$parent ? this.$parent.$attrs.gutter || 0 : 0)
    },
    style() {
      const ret = {}

      if (this.innerGutter) {
        ret.marginLeft = `-${this.innerGutter / 2}px`
        ret.marginRight = ret.marginLeft
      }

      return ret
    },
  },
  render(h) {
    return h(
      this.tag,
      {
        class: [
          'km-row',
          this.justify !== 'start' ? `is-justify-${this.justify}` : '',
          this.align !== 'top' ? `is-align-${this.align}` : '',
          {
            'km-row--flex': this.flex,
            debug: this.debug,
          },
        ],
        style: this.style,
      },
      this.$slots.default,
    )
  },
}
